import consumer from "./consumer"
import Toastify from "toastify-js";

const cable = consumer || (window.App && window.App.cable);
const AUTO_HIDE_BADGE_MS = 10000;
const badgeResetTimers = new Map();
let activeToast = null; // Track the current active toast

function isChatPage() {
  return Boolean(document.getElementById("js-chat-box"));
}

function updateWithAutoReset(el, html) {
  if (!el) {
    return;
  }

  if (!isChatPage()) {
    el.innerHTML = html;
    return;
  }

  if (!el.dataset.badgeResetHtml) {
    el.dataset.badgeResetHtml = el.innerHTML;
  }

  el.innerHTML = html;

  const existingTimer = badgeResetTimers.get(el);
  if (existingTimer) {
    clearTimeout(existingTimer);
  }

  const timer = setTimeout(() => {
    el.innerHTML = el.dataset.badgeResetHtml || "";
    badgeResetTimers.delete(el);
  }, AUTO_HIDE_BADGE_MS);

  badgeResetTimers.set(el, timer);
}

if (!cable) {
  console.warn("BadgeChannel: missing ActionCable consumer; subscription skipped.");
} else if (!window.CURRENT_USER_ID) {
  console.warn("BadgeChannel: missing CURRENT_USER_ID; subscription skipped.");
} else {
  const USER_ID = String(window.CURRENT_USER_ID);

  cable.subscriptions.create({channel: "BadgeChannel", user_id: USER_ID}, {
    connected() {
      // Called when the subscription is ready for use on the server
      console.log("badge channel connected");
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      const msg_menu = document.getElementById("messages-menu-item");
      updateWithAutoReset(msg_menu, data.msg_counter);
      const sb_msg_count = document.getElementById("sidebar-msg-count");
      updateWithAutoReset(sb_msg_count, data.sidebar_msg_counter);
      const pr_msg_count = document.getElementById("unread-inbox-badge");
      const message_body = document.getElementById("message_body");
      if(pr_msg_count && message_body === null) {
        pr_msg_count.innerHTML = data.profile_msg_counter;
      }

      // Hide previous toast if exists
      if (activeToast) {
        activeToast.hideToast();
      }

      // Show new toast and track it
      activeToast = Toastify({
        text: data.msg_text,
        duration: 10000,
        close: true,
        gravity: "top", // top o bottom
        position: "right", // right, left o center
        style: {background: "#4fbe87", cursor: "pointer"},
        onClick: function() {
          // Navigate to the chat page via conversation_chat_path
          if (data.conversation_id) {
            const locale = window.CURRENT_LOCALE || document.documentElement.lang || 'it';
            window.location.href = `/${locale}/chat/${data.conversation_id}.html`;
          }
        },
        callback: function() {
          // Clear reference when toast is hidden/closed
          if (activeToast === this) {
            activeToast = null;
          }
        }
      });

      activeToast.showToast();

      const chatRow = document.getElementById(`chat-row-${data.conversation_id}`);

      if (chatRow) {
        chatRow.classList.add("new-messages");
      }

    }
  });
}
